import { color } from "framer-motion";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Select, { StylesConfig } from "react-select";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const UISelect = ({
  isDisabled,
  options,
  selectedValues,
  onChange,
  placeholder,
  size,
  isMulti = false,
  ref,
  isClearable = false,
  onInputChange,
  label,
  required = false,
  tooltipText,
  border = true,
  isSearchable = false,
  error = false,
  isTopBar = false,
  menuPlacement = "bottom",
  loginSelectDesign = false,
  fullwidth = false,
  startIcon = undefined,
  relative = false,
  fullWidth = false,
  ...props
}) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedValues || []);
  const { i18n } = useTranslation();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:767px)");

  const app = useSelector((state) => state?.app);

  useEffect(() => {
    setSelectedOptions(selectedValues);
  }, [selectedValues]);

  const handleSelectChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    if (onChange) {
      onChange(selectedOptions);
    }
  };
  const themes = {
    light: {
      optionBackgroundColor: "transparent",
      menuBg: "#fff",
      textColor: "black",
    },
    dark: {
      optionBackgroundColor: "#201F48",
      menuBg: "#201F48",
      textColor: "#fff",
    },
  };

  const getCustomStyles = (theme) => ({
    control: (provided) => ({
      ...provided,
      backgroundColor: loginSelectDesign ? "#ab6dd8" : "transparent",
      padding: size === "medium" && "7px",
      fontSize: loginSelectDesign
        ? "1.5vh"
        : isMobile
        ? "1.2vh"
        : size === "medium"
        ? "16px"
        : isTopBar && "1vw",
      border: border
        ? error
          ? "1px solid #d32f2f"
          : loginSelectDesign
          ? "1px solid white"
          : provided?.border
        : loginSelectDesign
        ? "1px solid white"
        : "none",
      boxShadow: border ? provided?.boxShadow : "none",
      borderColor:
        theme === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)",
      minHeight: isMobile ? "0px" : "",
      // padding: isDisabled || size === "x-small" ? "3px 2px" : "",
      padding: isDisabled || size === "x-small" ? "" : "",
    }),
    input: (provided) => ({
      ...provided,
      color: themes[theme]?.textColor,
      border: border ? provided?.border : "none",
    }),
    singleValue: (provided, { isDisabled }) => ({
      ...provided,
      color:
      location.pathname === "/login"
      ? "white"
      : isDisabled
      ? "#808080c4"
      : props?.sideBarTextColor || themes[theme]?.textColor,
      border: border ? provided?.border : "none",
      textAlign: 'left'
    }),
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      backgroundColor:
        isSelected && data?.id === selectedOptions?.id
          ? "#5d5fef"
          : themes[theme].optionBackgroundColor,
      fontSize: isMobile
        ? "1.2vh"
        : size === "medium"
        ? "16px"
        : isTopBar && "1vw",
      border: border ? provided?.border : "none",
      color: data?.color || provided?.color,
      cursor: props?.cursor
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      backgroundColor: themes[theme].optionBackgroundColor,
      fontSize: size === "medium" && "16px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: "black",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000,
      backgroundColor: themes[theme].menuBg,
      position: relative ? "relative" : "absolute", 
      width: relative || (fullwidth || fullWidth) ? "100%" : "default", 
      marginTop: relative ? "4px" : "default"
    }),
    placeholder: (provided) => ({
      ...provided,
      color: loginSelectDesign ? "white" : theme === "dark" ? "#aaa" : "#aaa", // Change this to the desired color
      opacity: 1,
      fontWeight: 500,
    }),
    // indicatorSeparator: (provided) => {
    //   if (isTopBar) {
    //     return {
    //       ...provided,
    //       width: isTopBar && "0.1vw",
    //       height: isTopBar && "2vw",
    //       margin: isTopBar && "auto 0",
    //     };
    //   } else {
    //     return {
    //       ...provided,
    //     };
    //   }
    // },
    indicatorSeparator: (provided, { isDisabled }) => ({
      ...provided,
      backgroundColor: isDisabled ? "#999" : provided.backgroundColor,
      ...(isTopBar && {
        width: "0.1vw",
        height: "2vw",
        margin: "auto 0",
      }),
      visibility: isDisabled ? "hidden" : "",
    }),
    dropdownIndicator: (provided, { isDisabled }) => ({
      ...provided,
      color: isDisabled ? "#999" : provided.color,
      svg: {
        width: isTopBar ? "1.5vw" : isMobile?"1.5vh":"1em",
        height: isTopBar ? "1.5vw" : isMobile?"1.5vh":"1em",
        color: isDisabled
          ? "#999"
          : theme === "dark"
          ? "#fff"
          : "#121212a3",
      },
      visibility: isDisabled ? "hidden" : "",
      ...(size === "x-small" && { padding: "2px 10px" }),
    }),
  });

  const customStyles = getCustomStyles(app?.theme);
  // const customStyles = getCustomStyles(app?.theme, menuPlacement);

  const customTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "#5c5fef", // Set your primary color here
      primary75: "#8a8af7", // 15% lighter than primary color
      primary50: "#b6b6fa", // 50% lighter than primary color
      primary25: "#d9d9fc", // 75% lighter than primary color

      // Secondary color (you can customize these as needed)
      secondary: "#ff8c00",
      secondary75: "#ffa54f",
      secondary50: "#ffbb71",
      secondary25: "#ffd699",
    },
  });

  const getNoOptionsMessage = () => {
    return i18n?.t("common.NO_OPTIONS");
  };

  const newFunction = (input) => {
    // console.log(input);
  };

  return (
    <div className={`d-flex align-items-center ${(fullwidth || fullWidth) ? "w-100" : ""}`}>
      <div>{startIcon && (startIcon)}</div>
      {label && (
        <div className="fxs b-500">
          {label}
          {required && (
            <span className="text-danger b-500" style={{ fontSize: "14px" }}>
              *
            </span>
          )}
        </div>
      )}
      <div title={tooltipText || ""} className={(fullwidth || fullWidth) && "w-100"}>
        <Select
          options={Array.isArray(options) ? options : []}
          menuPlacement={menuPlacement}
          isClearable={isClearable}
          placeholder={placeholder || "Select..."}
          theme={customTheme}
          value={selectedOptions}
          styles={customStyles}
          onChange={handleSelectChange}
          onInputChange={(input) =>
            typeof onInputChange === "function"
              ? onInputChange(input)
              : newFunction(input)
          }
          autosize={true}
          isDisabled={isDisabled}
          noOptionsMessage={getNoOptionsMessage}
          isSearchable={isSearchable}
          {...props}
        />
      </div>
    </div>
  );
};

export default UISelect;
